import { AppThunkAction, AppThunkActionAsync } from "..";
import * as actions from "./actions";
import clientApi from "../../api/client";
import { selectClientNoteList } from ".";
import { IFilterType } from "../filterType";
import { CancelToken } from "axios";
import {
  listEffectCountFilter,
  listEffectGetFilter,
  listEffectLoad,
  listEffectReload,
  listEffectsCountCheck,
  listEffectsGetCheck,
  listEffectsGetCount,
  listEffectsGetNew,
  listEffectsGetParams,
} from "../listEffect";
import { getAvailableInformationTypes } from "../informationType";

export function getClientNoteList(
  clientId: number,
  cancelToken: CancelToken
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectClientNoteList(getState());
    if (listEffectsGetCheck(state.state)) {
      return;
    }

    let newState = listEffectsGetNew(state);
    dispatch(actions.clientNoteListFetchRequest(newState.newCountState));
    try {
      const params = listEffectsGetParams(state, newState.take);
      listEffectGetFilter(params, state.filter);

      const notes = await clientApi.getClientNoteList(clientId, {
        params,
        cancelToken,
      });
      cancelToken.throwIfRequested();
      newState = listEffectsGetCount(newState, notes);

      dispatch(
        actions.clientNoteListFetchSuccess({
          data: notes.data,
          newCountState: newState.newCountState,
          newCount: newState.newCount,
        })
      );
    } catch {
      dispatch(
        actions.clientNoteListFetchError(cancelToken.reason !== undefined)
      );
    }
  };
}

export function getClientNoteListCount(
  clientId: number,
  cancelToken: CancelToken
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectClientNoteList(getState());
    if (listEffectsCountCheck(state.countState)) {
      return;
    }

    dispatch(actions.clientNoteListCountRequest());
    try {
      const params = listEffectCountFilter(state.filter);
      const count = await clientApi.getClientNoteCount(clientId, {
        params,
        cancelToken,
      });
      cancelToken.throwIfRequested();

      dispatch(actions.clientNoteListCountSuccess(count.data));
    } catch {
      dispatch(
        actions.clientNoteListCountError(cancelToken.reason !== undefined)
      );
    }
  };
}

export function changeClientNoteListOrder(
  orderBy: string,
  orderDesc: boolean
): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.clientNoteListChangeOrder({ orderBy, orderDesc }));
  };
}

export function changeClientNoteListPage(page: number): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.clientNoteListChangePage(page));
  };
}

export function changeClientNoteListFilter(
  filter: IFilterType
): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.clientNoteListChangeFilter(filter));
  };
}

export function clientNoteListLoad(reload: boolean): AppThunkAction {
  return async (dispatch, getState) => {
    dispatch(getAvailableInformationTypes());
    const state = selectClientNoteList(getState());
    reload = listEffectReload(reload, state);
    if (reload) {
      dispatch(actions.clientNoteListReset());
    } else {
      const newState = listEffectLoad(state);
      dispatch(
        actions.clientNoteListLoadAction({
          newState: newState.newState,
          newCountState: newState.newCountState,
        })
      );
    }
  };
}
